// extracted by mini-css-extract-plugin
module.exports = {"notification":"NewsletterPopup_notification__A__Bp"};